import React, { useState, useEffect } from "react";
import useAxios from "../services/useAxios";

type productType = {
  label: string;
  value: string;
};
type productValueType = {
  title: string;
  id: string;
};
type factorDataType = {};
type ContextType = {
  productTypeList: productType[];
  priceType: productType[];
  productList: productValueType[];
  productListBasedOnType: (type: {}) => void;
  factorDataForPrint: factorDataType;
  factorToPrintFunc: (data: {}) => void;
};

const UseFullDataContext = React.createContext<ContextType>({
  productTypeList: [],
  priceType: [],
  productListBasedOnType: () => {},
  productList: [],
  factorDataForPrint: {},
  factorToPrintFunc: () => {},
});
export default UseFullDataContext;

interface ProviderProps {
  children: JSX.Element | JSX.Element[];
}
export const UseFullDataProvider: React.FC<ProviderProps> = ({ children }) => {
  const { execute: getProductStructuresAPI } = useAxios(
    "api/get_product_structures"
  );
  const { execute: findProductsApi } = useAxios("api/Find_products");
  const priceType = [
    { label: "مبلغ", value: "1" },
    { label: "درصد", value: "2" },
  ];
  const [productTypeList, setProductTypeList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [factorDataForPrint, setFactorDataForPrint] = useState({});
  const factorToPrintFunc = (data: {}) => {
    setFactorDataForPrint(data);
  };
  const getProductTypeFunc = async () => {
    // product structure api data
    await getProductStructuresAPI().then((res) => {
      let tempResult = res?.data?.prepared_messages_categories ?? [];
      tempResult = Object.keys(tempResult).map((value) => {
        return { label: tempResult[value], value: value };
      });
      setProductTypeList(tempResult);
    });
  };
  const productListBasedOnType = async (type: {}) => {
    await findProductsApi(type).then((res) => {
      setProductList(
        res.map((v: { title: ""; id: "" }) => {
          return { ...v, label: v.title, value: v.id };
        })
      );
    });
  };

  useEffect(() => {
    async function getDatas() {
      await getProductTypeFunc();
    }
    getDatas();
  }, []);

  let state = {
    productTypeList,
    priceType,
    productListBasedOnType,
    productList,
    factorDataForPrint,
    factorToPrintFunc,
  };
  return (
    <UseFullDataContext.Provider value={state}>
      {children}
    </UseFullDataContext.Provider>
  );
};
